import { ADM_FORMAT } from "./constants";

export type ADMCampaignData = {
  id: number;
  startDate: string;
  updatedAt: string;
  flyerType: ADM_FORMAT;
  flyersCount: number | null;
  flyerWeight: string | null;
  campaignDuration: number | null;
  missionsCount: number | null;
  totalCosts: number;
  taxes: number | null;
  subtotal: number | null;
  dataCost?: number | null;
  lastActiveStep: string;
  internalStatus: string;
  submittedBy: string | null;
  qrCodeLink: string | null;
  stripeCouponCode: string | null;
  amountOff: number | null;
  percentOff: number | null;
  isPaymentSkipped: boolean;
  baPerLocation: number | null;
  isTrackableCoupon: number;
  couponType: string | null;
  staticCouponCode: string | null;
  dynamicCouponCode: string | null;
  channel: string;
  printingCostPerFlyer: number;
  subtype: string;
  campaignName: string;
  campaignComments: string | null;
  country: {
    id: string;
  };
  client: {
    id: string;
    name: string;
    logo: string;
  };
  campaignFlyerInfo: {
    s3Link: string;
    flyerName: string;
    isFlyerUploaded: boolean | null;
    activeRoomId: string | null;
  };
  quote: string;
  purchaseOrderNumber: string | null;
  isSubmitted: boolean;
  status: "DRAFT" | "ACTIVE" | "COMPLETED" | "ARCHIVED";
  updateAddressOnMove: boolean;
  reviewMeetingDate?: number;
  returnAddressId?: number | null;
};

export type AudienceMetadata = {
  fileUrl: string;
  headers: string[];
  firstRow: string[];
  headersMap: Record<string, string>;
  rowsAmount: number;
};

export enum AudienceStatus {
  CREATED = "CREATED",
  PROCESSING = "PROCESSING",
  READY = "READY",
  REFRESHING = "REFRESHING",
  FAILED = "FAILED",
  ARCHIVED = "ARCHIVED",
}

export type Audience = {
  id: number;
  name: string;
  csvUrl: string;
  clientId: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  metadata: AudienceMetadata;
  filters?: any | null;
  sourceType?: string | number;
  source_type?: string | number;
  status: AudienceStatus;
};

export type CampaignCostPreviewLine = {
  title: string;
  quantity: number;
  price: number;
};

export type CampaignCostPreview = {
  lines: CampaignCostPreviewLine[];
  subtotal: number;
  tax?: number;
  total?: number;
  amountOff?: number;
  dataCost?: number;
};

export type CampaignAudience = {
  id: number;
  campaign_id: number;
  audience_id: number;
  created_at: string;
  updated_at: string;
};
